import { render, staticRenderFns } from "./OfficeIdentityPage.vue?vue&type=template&id=66842bf2&scoped=true&"
import script from "./OfficeIdentityPage.vue?vue&type=script&lang=js&"
export * from "./OfficeIdentityPage.vue?vue&type=script&lang=js&"
import style0 from "./OfficeIdentityPage.vue?vue&type=style&index=0&id=66842bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66842bf2",
  null
  
)

export default component.exports